import { useToast } from 'vue-toast-notification'

// Тосты биржи через общий механизм main-front (vue-toast-notification, тема theme-mindm.css;
// RD-164 decisions.md: без отдельного контейнера/провайдера). Сообщение — заголовок, текст и
// необязательное действие; одно действие — одна обратная связь: повтор с тем же key заменяет тост.

export interface ExchangeToastAction {
    label: string
    run: () => void
}

interface ToastOptions {
    text?: string
    action?: ExchangeToastAction | null
    key?: string
}

const toast = useToast({ position: 'bottom-right' })
const visible = new Map<string, { dismiss: () => void }>()

// Библиотека выводит message через innerHTML — данные (ФИО, сообщения сервера) экранируются.
function escapeHtml(value: string): string {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
}

function show(type: 'success' | 'error', title: string, options: ToastOptions = {}) {
    const key = options.key ?? `${type}:${title}:${options.text ?? ''}`
    visible.get(key)?.dismiss()
    const action = options.action ?? null
    const message = [
        '<span class="ds-toast-body">',
        `<span class="ds-toast-title">${escapeHtml(title)}</span>`,
        options.text ? `<span class="ds-toast-text">${escapeHtml(options.text)}</span>` : '',
        '</span>',
        action ? `<button type="button" class="ds-toast-action" data-toast-action>${escapeHtml(action.label)}</button>` : '',
    ].join('')
    const instance = toast.open({
        message,
        type,
        duration: type === 'error' ? 8000 : 5000,
        // Клик по тосту закрывает его (как у всех тостов приложения); по кнопке — ещё и выполняет действие.
        onClick: (event?: MouseEvent) => {
            const target = event?.target as HTMLElement | null
            if (action && target?.closest('[data-toast-action]')) action.run()
        },
        onDismiss: () => {
            if (visible.get(key) === instance) visible.delete(key)
        },
    })
    visible.set(key, instance)
}

export const exchangeToast = {
    success: (title: string, options?: ToastOptions) => show('success', title, options),
    error: (title: string, options?: ToastOptions) => show('error', title, options),
}
